<template>
  <div>
    <b-modal
        id="modal-delete-media-item"
        ref="modal-delete-media-item"
        footer-class="flex-nowrap"
        no-close-on-backdrop
        no-close-on-esc
        centered
    >
      <template #modal-header>
        <h3>{{ $t('modals.deleteMediaItem.title') }}</h3>
      </template>

      <template #default>
        <div class="delete-icon text-center">
          <b-icon icon="exclamation-triangle-fill" variant="danger" class="mt-5 mb-4"></b-icon>
          <div v-if="image" class="mt-2 mb-3 media-name">{{ image.name }}</div>
          <div class="mt-2 mb-4">{{ $t('modals.deleteMediaItem.message') }}</div>
          <div class="mt-2 mb-4 text-warning small">
            {{ $t('modals.deleteMediaItem.warning') }}
          </div>
        </div>
      </template>

      <template #modal-footer>
        <b-button
            class="p-3 border-right-light-grey"
            block
            :disabled="isDeleting"
            @click="cancelModal"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
            variant="primary"
            class="p-3"
            block
            :disabled="isDeleting"
            @click="confirmDelete"
        >
          <b-spinner v-if="isDeleting" small />
          <span v-else>{{ $t('modals.deleteMediaItem.validate') }}</span>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalDeleteMediaItem',
  props: {
    image: {
      type: Object,
      default: null,
    },
    isDeleting: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$refs['modal-delete-media-item'].show();
  },
  methods: {
    confirmDelete() {
      this.$emit('delete-media-item');
    },
    cancelModal() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped lang="scss">
.delete-icon svg {
  font-size: 80px;
}

.media-name {
  font-weight: 600;
  word-break: break-word;
}
</style>
